// extracted by mini-css-extract-plugin
export default {"AssigneeCell":"AssigneeCell_AssigneeCell__t6BFS"};